import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { getProfile, logout } from "../store/slices/auth";


import '../header.css';

export default function Header({
    collapsed,
    onToggle,
    onMenuToggle
}) {

    const dispatch = useDispatch();

    const navigate = useNavigate();


    const [notifOpen, setNotifOpen] = useState(false);
    const [profileOpen, setProfileOpen] = useState(false);

    useEffect(() => {
        dispatch(getProfile());
    }, [dispatch]);

    // GET PROFILE FROM REDUX
    const { profile } = useSelector(
        (state) => state.auth
    );

    const username =
        profile?.data?.name || "User";

    const role =
        profile?.data?.role;

    const email =
        profile?.data?.email;


    const initials =
        username
            ?.split(" ")
            ?.map((word) => word[0])
            ?.join("")
            ?.slice(0, 2)
            ?.toUpperCase() || "";

    /* LOGOUT */

    const handleLogout = async () => {

        await dispatch(logout());

        navigate("/");
    };


    return (

        <header className={`sar-header${collapsed ? " sidebar-collapsed" : ""}`}>



            <button
                className="header-hamburger"
                onClick={onMenuToggle}
                title="Open menu"
            >
                <i className="bi bi-list" />
            </button>



            <button
                className="header-toggle-btn"
                onClick={onToggle}
                title={
                    collapsed
                        ? "Expand sidebar"
                        : "Collapse sidebar"
                }
            >
                <i
                    className={`bi ${collapsed
                        ? "bi-layout-sidebar"
                        : "bi-layout-sidebar-reverse"
                        }`}
                />
            </button>



            <div className="header-page-title">
                Cashback Promoters and Developers
            </div>

            <div className="header-spacer" />





            {/* PROFILE */}

            <div
                className="header-profile"
                onClick={() => {

                    setProfileOpen(!profileOpen);
                    setNotifOpen(false);

                }}
            >

                <div className="profile-avatar">
                    {initials}
                </div>

                <span className="profile-name">
                    {username}
                </span>

                <i
                    className={`bi bi-chevron-${profileOpen ? "up" : "down"
                        } profile-caret`}
                />

                {profileOpen && (

                    <div
                        className="profile-dropdown"
                        onClick={(e) => e.stopPropagation()}
                    >


                        <div className="profile-header-section">

                            <div className="profile-full-name">
                                {username}
                            </div>

                            <div className="profile-email">
                                {email}
                            </div>

                            <div
                                style={{
                                    marginTop: "6px",
                                    fontSize: "11px",
                                    color: "#FFD600",
                                    textTransform: "uppercase",
                                    fontWeight: "600",
                                    letterSpacing: "1px"
                                }}
                            >
                                {role}
                            </div>

                        </div>



                        {[
                            {
                                icon: "bi-person",
                                label: "Profile",
                                path: role === "admin" ? "/admin/profile" : "/user/profile",
                            },
                            // {
                            //     icon: "bi-gear",
                            //     label: "Settings",
                            //     path: "/user/settings"
                            // },

                        ].map((item) => (

                            <div
                                className="profile-menu-item"
                                key={item.label}
                                onClick={() => {
                                    if (item.path) {
                                        navigate(item.path);
                                    }
                                }}
                                style={{
                                    cursor: item.path ? "pointer" : "not-allowed",
                                    opacity: item.path ? 1 : 0.5
                                }}
                            >

                                <i className={`bi ${item.icon}`} />

                                {item.label}

                            </div>

                        ))}
                        {/* LOGOUT */}

                        <div
                            className="profile-menu-item danger"
                            onClick={handleLogout}
                        >

                            <i className="bi bi-box-arrow-right" />

                            Sign Out

                        </div>

                    </div>

                )}

            </div>

        </header>
    );
}